import API from './../../api'
import _ from 'lodash';

/**
 * Person Form Validator
 */
export default {
  namespaced: true,
  state: {
    page: {},
    hasUserSaved: false,
    hasUserSubscribed: false,
  },
  mutations: {
    setPage (state, page) {
      state.page = page
    },
    setHasUserSaved (state, hasUserSaved) {
      state.hasUserSaved = hasUserSaved
    },
    setHasUserSubscribed (state, hasUserSubscribed) {
      state.hasUserSubscribed = hasUserSubscribed
    },
    setPageSaved (state, userRequest) {
      state.page = _.merge(state.page, {userRequest: userRequest});
    },
  },

  actions: {
    savePage: async ({ commit, state }) => {
      await commit("setHasUserSaved", true);
      try {
        let page = await API.saveRequest(state.page.unifiedAddressID);
        await commit("setPage", page);
      } catch (e) {
        console.log(e);
      }
    },

    deletePage: async ({ commit, state }) => {
      console.log("delete");
      if (state.page.userRequest) {
        let userRequestID = state.page.userRequest.requestId;
        await commit("setHasUserSaved", false);
        try {
          await API.deleteUserRequests(userRequestID);
        } catch (e) {
          console.log(e);
        }
      }
    },

    toggleNotification: async ({ commit, state }) => {
      if (state.page.userRequest) {
        let subscribe = !(state.page.userRequest.subscription === "SUBSCRIBED");
        commit("setHasUserSubscribed", subscribe);
        try {
          let userRequest = await API.subToggle(state.page.userRequest.requestId, subscribe);
          commit("setPageSaved", userRequest);
        } catch (e) {
          console.log(e);
        }
      }

      return true;
    },

    /**
     * Get a page
     * @param commit
     * @param pageID
     * @returns {Promise<void>}
     */
    getPage: async ({ commit }, pageID) => {
      commit('setLoading', true, { root: true })
      try {
        const page = await API.fetchPage(pageID);
        await commit('toggleMessage', false, { root: true});
        await commit('setLoading', false, { root: true });
        await commit('setPage', page);
        if (page.userRequest) {
          await commit("setHasUserSaved", true);
          await commit("setHasUserSubscribed", page.userRequest.subscription === "SUBSCRIBED");
        } else {
          await commit("setHasUserSaved", false);
          await commit("setHasUserSubscribed", false);
        }
        let reportDate = new Date(Date.parse(page.reportDate));
        reportDate.setDate(reportDate.getDate()+100);
        let now = new Date();
        if (reportDate < now) {
          await commit('toggleMessage', true, { root: true });
          await commit('setMessage', {
            type: 'info',
            subject: "Expired Report",
            message: "You are viewing an expired report. At BCHome.ai, we updates home value every month. Please use \"Search\" to get latest report of the property"
          }, { root: true })
        }

      } catch (e) {
        await commit('setLoading', false, { root: true });
        await commit('toggleMessage', true, { root: true });
        switch (e.response.data.key) {
          case "no-page-found":
            await commit('setMessage', {
              type: 'danger',
              subject: "Page not found",
              message: "Sorry, we are not able to find the page."
            }, { root: true })
            break;
        }
      }
    },
  },
  getters: {
    page: state => state.page,
    hasUserSaved: state => state.hasUserSaved,
    hasUserSubscribed: state => state.hasUserSubscribed,
    nearbyProperties: state => {
      let properties = [];
      for (const k in state.page.properties) {
         if (k !== state.page.unifiedAddressID && state.page.properties[k].hasReport === true) {
           properties.push(state.page.properties[k]);
         }
      }
      properties = properties.sort((a,b) => {
        return a.distance - b.distance;
      });
      return properties;
    }
  }
}
